<template>
  <div style="margin-bottom:30px;">
    <el-form-item :prop="elementDefinition.key" :label="elementDefinition.label">
      <p>{{fieldName}}</p>
        <el-input @change="handleChange" v-model="selectedValue"></el-input>
    </el-form-item>
  </div>
</template>

<script>
    export default {
        name: "FormElementGeneric",
        props: [
            'fieldName',
            'initialValue',
            'handleFormElementValueChange'
        ],
        data() {
            return {
                selectedValue: null,
            }
        },
        mounted() {
            this.selectedValue = this.initialValue
        },
        watch: {
            initialValue: function(val) {
                this.selectedValue = val
            }
        },
        methods: {
            handleChange(field_value) {
                let field_name = this.fieldName
                this.$emit('handleFormElementValueChange', {field_value, field_name})
            },
        }
    }
</script>

<style scoped>

</style>